import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Leaf } from 'lucide-react';

const Hero = () => {
  return (
    <section id="home" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-lightbg">
      {/* Premium Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 bg-slate-50">
        <div className="bg-grid-pattern absolute inset-0 opacity-40"></div>
        <div className="orb-1 -top-40 -right-20"></div>
        <div className="orb-2 top-40 -left-20"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-white shadow-sm border border-emerald-100 text-teal-800 font-semibold mb-6">
              <Leaf className="w-4 h-4 mr-2 text-emerald-500" />
              <span>Leading Net Zero Consultancy</span>
            </div>
            <h1 className="text-5xl lg:text-7xl font-extrabold text-slate-900 leading-[1.1] mb-6 tracking-tight">
              Empowering Your <br className="hidden lg:block" />
              <span className="premium-gradient-text">Net Zero</span> Journey
            </h1>
            <p className="text-xl text-slate-600 mb-10 leading-relaxed max-w-xl">
              We partner with businesses to reduce carbon footprints, create sustainable growth opportunities, and contribute to a cleaner, healthier planet.
            </p>
            <div className="flex flex-col sm:flex-row gap-5">
              <button className="btn-premium weightless-btn flex items-center justify-center">
                Explore Solutions
                <ArrowRight className="ml-2 w-5 h-5" />
              </button>
              <button className="bg-white hover:bg-slate-50 text-slate-800 border-2 border-slate-200 hover:border-slate-300 px-8 py-4 rounded-full font-bold text-lg transition-all flex items-center justify-center shadow-sm weightless-btn">
                Learn More
              </button>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative antigravity-float"
          >
            {/* Eco Illustration Placeholder using a nature image */}
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
              <img 
                src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" 
                alt="Wind turbines in lush green landscape" 
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teal-900/40 to-transparent"></div>
            </div>
            
            {/* Floating stats card */}
            <motion.div 
              animate={{ y: [-10, 10, -10] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
              className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl border border-emerald-100"
            >
              <div className="flex items-center gap-4">
                <div className="bg-emerald-100 p-3 rounded-full text-primary">
                  <Leaf className="w-8 h-8" />
                </div>
                <div>
                  <p className="text-3xl font-bold text-teal-950">100%</p>
                  <p className="text-sm font-medium text-gray-500">Eco-Friendly Focus</p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
